// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2VMry","inputWrap":"Table_inputWrap__Mp12t","col":"Table_col__2sAJR","bmiTooltip":"Table_bmiTooltip__1Ga8l"};